import React from "react";

export const ScoreRing = ({ score = 0, size = 56, label = "Wikifi" }) => {
  const radius = (size - 10) / 2;
  const c = 2 * Math.PI * radius;
  const offset = c - (score / 100) * c;
  const color = score >= 90 ? "#0B1220" : score >= 80 ? "#2C3E5C" : score >= 70 ? "#5B6478" : "#A0A8BC";
  return (
    <div className="flex flex-col items-center" data-testid="score-ring">
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="-rotate-90">
          <circle cx={size/2} cy={size/2} r={radius} stroke="#EDF1F7" strokeWidth="5" fill="none" />
          <circle cx={size/2} cy={size/2} r={radius} stroke={color} strokeWidth="5" fill="none"
                  strokeDasharray={c} strokeDashoffset={offset} strokeLinecap="round" />
        </svg>
        <div className="absolute inset-0 flex items-center justify-center text-[#0B1220] font-bold text-sm">{score}</div>
      </div>
      <span className="text-[10px] font-bold tracking-widest text-[#5B6478] uppercase mt-1">{label}</span>
    </div>
  );
};

export const StarScore = ({ score = 0, votes = 0 }) => (
  <div className="flex flex-col items-center" data-testid="star-score">
    <div className="flex items-center gap-0.5">
      {[1,2,3,4,5].map(i => (
        <svg key={i} width="13" height="13" viewBox="0 0 24 24"
             fill={i <= Math.round(score) ? "#F97316" : "none"}
             stroke="#F97316" strokeWidth="1.5">
          <path d="M12 2l3 7h7l-5.5 4.5L18 21l-6-4-6 4 1.5-7.5L2 9h7z"/>
        </svg>
      ))}
    </div>
    <div className="text-xs text-[#0B1220] font-semibold mt-1">{score.toFixed(1)}</div>
    <span className="text-[10px] font-bold tracking-widest text-[#5B6478] uppercase">Users · {votes.toLocaleString()}</span>
  </div>
);
